import React from 'react';

import type { Nullable } from '@clearverify/types';

import {
  IntegrationUsageLogOrderBy,
  IntegrationUsageLogWhere,
  useIntegrationUsageLogsListQuery,
} from 'src/api';
import { PaginationQueryVariables } from 'src/hooks/common';

export const useIntegrationUsageLogs = (
  filter?: IntegrationUsageLogWhere,
  sort?: Nullable<IntegrationUsageLogOrderBy>,
  paginationVariables?: PaginationQueryVariables,
  notifyOnNetworkStatusChange?: boolean,
) => {
  const { data, loading, refetch } = useIntegrationUsageLogsListQuery({
    variables: {
      filter,
      orderBy: sort,
      ...paginationVariables,
    },
    notifyOnNetworkStatusChange,
  });

  const integrationUsageLogsList = React.useMemo(() => {
    return data?.integrationUsageLogList ?? [];
  }, [data?.integrationUsageLogList]);

  const integrationUsageLogsCount = React.useMemo(() => {
    return data?.integrationUsageLogCount || 0;
  }, [data?.integrationUsageLogCount]);

  return {
    integrationUsageLogsList,
    integrationUsageLogsCount,
    integrationUsageLogsLoading: loading,
    refetch,
  };
};
